export const chartsWithStackedRequest = [
    'hyperSpaceStackedColumnChart',
    'hyperSpaceStackedBarChart',
    'stackedBarChart',
    'stackedColumnChart',
];

export const MULTI_TIME_PERIOD_KEY = '_ADDITIONAL_TIMEPERIOD_';
